module.exports = __webpack_public_path__ + "img/advisory_select_type_bj02.68e0aed5.png";